import { render, staticRenderFns } from "./approval-detail.vue?vue&type=template&id=3cb4787e&scoped=true"
import script from "./approval-detail.vue?vue&type=script&lang=js"
export * from "./approval-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb4787e",
  null
  
)

export default component.exports